import React, { useEffect } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState } from 'react';
import '../../../../components/SplitActions/style.scss';
import { Typography, useTheme, Tab, Tabs, Box, IconButton, Stack, Accordion, AccordionSummary, DialogActions, Button } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccessPermissionCard from './AccessPermissionCard';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { CancelToken } from 'apisauce';
import RolePrivilageDialog from './RolePrivilageDialog';
import AddEditUser from './AddEditUser';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export default function UserDetails({ isDrawerOpen, toggleDrawer, user, init,permission }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  let source = CancelToken.source();
  let source2 = CancelToken.source();

  const [userPermission, setUserPermission] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(false);
  const [openAddEditUser, setOpenAddEditUser] = useState(false);
  const [openRolePrivilage, setOpenRolePrivilage] = useState(false);
  const [roleId, setRoleId] = useState('');

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (user && user?._id) {
      initApi();
    } else {
      setUserPermission(null);
    }
    return () => {
      if (source) {
        source.cancel();
      }
      if (source2) {
        source2.cancel();
      }
    };
  }, [user]);

  const initApi = async () => {
    await getUserDetails();
  };



  const getUserDetails = async () => {
    setLoading(true);
    source2.cancel();
    source2 = CancelToken.source();
    const response = await appapi.get(
      `user-management/${user?._id}`,
      {},
      {
        cancelToken: source2.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setUserDetails(data?.response);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Stack
      flex={1}
      className={!isDrawerOpen ? 'shrinkside flex' : 'expandside flex'}
    >
      <div className="absolute ml-[-18px]">
        <IconButton
          disabled={!Boolean(user)}
          className="!shadow-2xl"
          sx={{ boxShadow: 'rgba(0, 0, 0, 0.5) 1px 5px 10px !important', '&:hover': { width: '40px !important', marginLeft: '-20px' } }}
          style={{
            color: '#00000',
            width: '20px',
            paddingTop: '10px',
            height: '40px',
            zIndex: 999,
            backgroundColor: '#FFFF',
            borderRadius: '10px 0px 0px 10px',
          }}
          onClick={() => {
            toggleDrawer();
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Stack
        flex={1}
        style={{ background: '#FFFF', border: !isDrawerOpen ? 'none' : '1px solid #14285A1A', width: !isDrawerOpen ? '0px' : '500px', borderRadius: 1 }}
        onClose={() => {
          toggleDrawer();
        }}
      >
        {isDrawerOpen ? (
          <>
            {userDetails?.length <= 0 && !loading && <NoDataFound />}
            {loading && (
              <Stack
                flex={1}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <ActivityIndicator />
              </Stack>
            )}
            {!loading && (
              <Stack flex={1}>
                <Box
                  sx={{
                    display: 'flex',
                    borderBottom: 1,
                    border: 'none',
                    color: 'rgba(255, 255, 255, 1)',
                    borderRadius: '5px 5px 0px 0px',
                    justifyContent: 'space-between',
                  }}
                >
                  <Stack
                    style={{ justifyContent: 'center' }}
                    className="px-[16px] !mt-[10px]"
                  >
                    <Typography
                      className="fw-medium ff-Roboto fs-16 uppercase"
                      color={text}
                    >
                      {t('Details')}
                    </Typography>
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                    >
                      <Typography
                        className="fw-medium ff-Roboto fs-10"
                        color={textLight}
                      >
                        {t('Last modified')}
                      </Typography>
                      <Typography
                        className="fw-medium ff-Roboto fs-10 !ml-[6px]"
                        color={text}
                      >
                        {moment(userDetails?.modifiedOn).format('DD-MMM-YYYY')}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    style={{ backgroundColor: '#00A6321A', alignItems: 'center', justifyContent: 'center', borderRadius: '16px' }}
                    className="px-[18px] my-[8px] mr-[16px]"
                  >
                    <Typography
                      className="fw-medium ff-Roboto fs-12 capitalize"
                      color={'#00A632'}
                    >
                      {t(userDetails?.roleId?.roleName) || '-'}
                    </Typography>
                  </Stack>
                </Box>
                <Stack
                  style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                  className="!my-[10px]"
                />
                <Stack className="flex flex-col flex-1 min-h-0">
                  <Stack
                    flexGrow={1}
                    className="relative"
                  >
                    <Stack className="flex-overflow py-2">
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        className="px-[16px]"
                      >
                        <Stack flex={0.5}>
                          <Typography
                            className="fs-12 ff-Roboto fw-regular"
                            color={text}
                          >
                            {t('Full name')}
                          </Typography>
                          <Typography
                            className="fs-14 ff-Roboto fw-medium"
                            color={text}
                          >
                            {userDetails?.name}
                          </Typography>
                          <Typography
                            className="fs-12 ff-Roboto fw-regular !mt-[16px]"
                            color={text}
                          >
                            
                            {t('Designation')}
                          </Typography>
                          <Typography
                            className="fs-14 ff-Roboto fw-medium"
                            color={text}
                          >
                            {userDetails?.designation}
                          </Typography>
                        </Stack>
                        <Stack flex={0.5}>
                          <Typography
                            className="fs-12 ff-Roboto fw-regular"
                            color={text}
                          >
                            {t('Email')}
                          </Typography>
                          <Typography
                            className="fs-14 ff-Roboto fw-medium"
                            color={text}
                          >
                            {userDetails?.email}
                          </Typography>
                          <Typography
                            className="fs-12 ff-Roboto fw-regular !mt-[16px]"
                            color={text}
                          >
                            {t('Phone')}
                          </Typography>
                          <Typography
                            className="fs-14 ff-Roboto fw-medium"
                            color={text}
                          >
                            {(userDetails?.phoneCode || '') + '-' + (userDetails?.phoneNumber || '')}
                          </Typography>
                        </Stack>
                      </Stack>
                      <div className="px-[16px]">
                        <Typography
                          className="fs-12 ff-Roboto fw-regular !mt-[20px] !mb-[10px]"
                          color={text}
                        >
                          {t('Access permissions')}
                        </Typography>
                        {(userDetails?.roleId?.modules || []).map((m, index) => <Accordion
                          key={index}
                          expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}
                          style={{ margin: '0px', height: 'auto' }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography
                              sx={{ width: '43%', flexShrink: 0 }}
                              className="fs-14 ff-Roboto fw-medium"
                              color={text}
                            >
                              {t(`${m?.moduleGroup}`)}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0px' }}>{<AccessPermissionCard permission={m?.permission || []} />}</AccordionDetails>
                        </Accordion>)}
                      </div>
                    </Stack>
                  </Stack>
                </Stack>

                <Stack alignItems={'flex-end'}>
                  {permission?.editAccess && <Button
                    sx={{
                      border: 1,
                      margin: '10px',
                      color: theme.palette.primary.text,
                      borderColor: '#14285A4D',
                      backgroundColor: '#FFFFFF',
                      '&:hover': {
                        borderColor: '#14285A4D',
                        backgroundColor: '#FFFFFF',
                        borderColor: '#14285A4D',
                      },
                    }}
                    className='uppercase'
                    style={buttonStyle2}
                    variant="contained"
                    // style={{ width: '128px', marginLeft: '80px', height: '40px', borderColor: '#14285A4D' }}
                    onClick={() => {
                      setOpenAddEditUser(true);
                    }}
                  >
                    {t('Edit details')}
                  </Button>}
                </Stack>
              </Stack>
            )}
          </>
        ) : null}
      </Stack>
      {openAddEditUser && (
        <AddEditUser
          type={'édit'}
          user={userDetails}
          openRolePrivilage={(roleId) => {
            setOpenRolePrivilage(true);
            setRoleId(roleId);
          }}
          modelOpen={openAddEditUser}
          onModelHandleClose={(event) => {
            if (event) {
              getUserDetails();
              init();
            }
            setOpenAddEditUser(false);
          }}
        />
      )}
      {openRolePrivilage && (
        <RolePrivilageDialog
          open={openRolePrivilage}
          handleClose={(event) => {
            if (event) {
              //   setPayload((prev) => ({ ...prev, page: 1 }));
              //   getCompanyList();
            }
            setOpenRolePrivilage(false);
          }}
          roleId={roleId}
        />
      )}
    </Stack>
  );
}
